import {
  PlateElement,
  PlateElementProps,
} from 'lib-knowledge-document-structure/plate/common';
import { ElementRef, forwardRef } from 'react';

export type PlateTableRowElementProps = PlateElementProps;

const TableRowBlock = forwardRef<
  ElementRef<typeof PlateElement>,
  PlateTableRowElementProps
>(({ children, ...props }, ref) => {
  return (
    <PlateElement asChild ref={ref} {...props}>
      <tr>{children}</tr>
    </PlateElement>
  );
});

TableRowBlock.displayName = 'TableRowBlock';

export { TableRowBlock };
